export default Object.freeze({
	sceneNotReady: 'Scene is not ready. Wait for sceneReady event before doing any actions.',
});
